import { getFetchWrapper } from '@syf-api-library/core';
import { getLanguageFromStorage } from 'syf-js-utilities';
/* istanbul ignore next */
var setRequestData = function () {
    var _a;
    return {
        'Accept-language': (_a = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('language')) === null || _a === void 0 ? void 0 : _a.toUpperCase()
    };
};
var getDisputesFetchWrapper = function (apiHost) {
    var disputeConfig = {
        hosts: {
            apigee: new URL(apiHost),
            assets: new URL('https://qa.synchronycredit.com')
        },
        apiErrorCallback: function () { return null; },
        lang: getLanguageFromStorage()
    };
    return getFetchWrapper(disputeConfig);
};
var fetchRequest = {
    get: function (apiHost, url) {
        var fetchWrapper = getDisputesFetchWrapper(apiHost);
        return fetchWrapper(url, {
            method: 'GET',
            headers: setRequestData()
        });
    },
    post: function (apiHost, url, payload) {
        var fetchWrapper = getDisputesFetchWrapper(apiHost);
        return fetchWrapper(url, {
            body: JSON.stringify(payload),
            method: 'POST',
            headers: setRequestData()
        });
    },
    patch: function (apiHost, url, payload) {
        var fetchWrapper = getDisputesFetchWrapper(apiHost);
        return fetchWrapper(url, {
            body: JSON.stringify(payload),
            method: 'PATCH',
            headers: setRequestData()
        });
    }
};
export default fetchRequest;
//# sourceMappingURL=fetchRequest.js.map